export default {"src":"/login-app/[GIT_HASH]/_next/static/media/open_in_new.7b1439fb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};